/*
 * Dogheroes — cross-sell quick-add (<dh-cross-sell>)
 *
 * Shared custom element used on the PDP (under the buy buttons) and inside
 * the cart drawer. Self-contained: injects its own styles, fetches
 * recommendations (complementary first via Search & Discovery, fallback to
 * related), renders compact pills, and adds to cart via /cart/add.js.
 *
 *   <dh-cross-sell data-product-id="123" data-context="pdp|cart"
 *                  data-intent="complementary" data-heading="..."></dh-cross-sell>
 *
 * Single-variant product  -> "+" : adds directly (quantity 1).
 * Multi-variant product   -> "+" : opens a modal with variant
 *                            selectors AND a quantity stepper.
 *
 * After add, a native-shaped `cart:update` (CartAddEvent) event is dispatched
 * on document so the Horizon cart drawer (auto-open) refreshes and opens.
 */
;(function () {
  if (window.__dhCrossSellLoaded) return
  window.__dhCrossSellLoaded = true

  var STYLE_ID = "dh-cross-sell-styles"

  function rootUrl() {
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/"
    return r.replace(/\/$/, "")
  }
  function recoUrl(intent, productId) {
    return (
      rootUrl() +
      "/recommendations/products.json?product_id=" +
      productId +
      "&limit=10&intent=" +
      intent
    )
  }
  function cartAddUrl() {
    return rootUrl() + "/cart/add.js"
  }
  function productJsUrl(handle) {
    return rootUrl() + "/products/" + handle + ".js"
  }

  function formatEuro(cents) {
    return "€" + (cents / 100).toFixed(2).replace(".", ",")
  }
  function escapeHtml(str) {
    return String(str == null ? "" : str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
  }
  function withWidth(src, w) {
    if (!src) return ""
    return src + (src.indexOf("?") >= 0 ? "&" : "?") + "width=" + w
  }

  // ------------------------------------------------------------- species utils
  function splitIds(str) {
    var ids = (str ? String(str).split(",") : [])
      .map(function (x) {
        return (x || "").trim()
      })
      .filter(Boolean)
    return ids.filter(function (v, i) {
      return ids.indexOf(v) === i
    })
  }
  // Specie del prodotto dal tag: "cat" se ha il tag cat, altrimenti "cane"
  // (tag dog o nessun tag specie).
  function speciesOf(p) {
    var tags = (p.tags || []).map(function (t) {
      return String(t).toLowerCase()
    })
    return tags.indexOf("cat") !== -1 ? "cat" : "dog"
  }
  function bySpecies(list, species) {
    return list.filter(function (p) {
      return speciesOf(p) === species
    })
  }
  function interleave(a, b) {
    var out = []
    var max = Math.max(a.length, b.length)
    for (var i = 0; i < max; i++) {
      if (i < a.length) out.push(a[i])
      if (i < b.length) out.push(b[i])
    }
    return out
  }
  function dedupByTarget(list) {
    var seen = {}
    var out = []
    list.forEach(function (p) {
      var k = targetIdOf(p)
      if (!seen[k]) {
        seen[k] = 1
        out.push(p)
      }
    })
    return out
  }
  function resolveHeading(el, speciesPresent) {
    if (el.dataset.heading) return el.dataset.heading
    var hasCat = speciesPresent.indexOf("cat") !== -1
    var hasDog = speciesPresent.indexOf("dog") !== -1
    if (hasCat && hasDog)
      return "Ai tuoi amici a 4 zampe potrebbero piacere anche:"
    if (hasCat) return "Al tuo gatto potrebbe piacere anche"
    return "Al tuo cane potrebbe piacere anche"
  }

  // base product handle -> { w: wrapper handle, min: prezzo minimo wrapper (cent) }
  // Mappa iniettata via Liquid (snippet dogheroes--cross-sell-bundle-map).
  // Per i prodotti mappati (frozen/pantry) il cross-sell usa le varianti del
  // wrapper multipack (gli stessi tagli/prezzi della PDP).
  function bundleFor(handle) {
    var m = window.DH_BUNDLE_MAP || {}
    var e = m[handle]
    if (!e) return null
    return typeof e === "string" ? { w: e, min: null } : e
  }

  // Id del prodotto che la pillola aggiunge davvero al carrello: per i prodotti
  // mappati (cane frozen/pantry, ricette gatto) e' il wrapper multipack, altrimenti
  // il prodotto stesso. Serve per dedup ed esclusioni "per target".
  function targetIdOf(p) {
    var b = bundleFor(p.handle)
    if (b && b.id != null) return String(b.id)
    return String(p.id)
  }

  // -------------------------------------------------------------- add to cart
  function addToCart(variantId, quantity, sourceBtn) {
    if (!variantId) return Promise.reject()
    if (sourceBtn) sourceBtn.setAttribute("aria-busy", "true")

    var formData = new FormData()
    formData.append("id", variantId)
    formData.append("quantity", quantity || 1)

    var sectionIds = []
    document.querySelectorAll("cart-items-component").forEach(function (el) {
      if (el.dataset && el.dataset.sectionId)
        sectionIds.push(el.dataset.sectionId)
    })
    if (sectionIds.length) formData.append("sections", sectionIds.join(","))

    return fetch(cartAddUrl(), {
      method: "POST",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: formData,
    })
      .then(function (r) {
        return r.json()
      })
      .then(function (response) {
        if (response && response.status) {
          throw new Error(
            response.description || response.message || "cart error"
          )
        }
        document.dispatchEvent(
          new CustomEvent("cart:update", {
            bubbles: true,
            detail: {
              resource: {},
              sourceId: "dogheroes-cross-sell",
              data: {
                source: "dogheroes-cross-sell",
                itemCount: quantity || 1,
                variantId: variantId,
                sections: response.sections,
              },
            },
          })
        )
        return response
      })
      .finally(function () {
        if (sourceBtn) sourceBtn.removeAttribute("aria-busy")
      })
  }

  // ------------------------------------------------------------------- modal
  var modal = null

  function ensureModal() {
    if (modal) return modal
    modal = document.createElement("dialog")
    modal.className = "dh-xsm-dialog"
    modal.innerHTML =
      '<div class="dh-xsm-card" role="dialog" aria-modal="true" aria-label="Scegli le opzioni">' +
      '  <button type="button" class="dh-xsm-close" aria-label="Chiudi">' +
      '    <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M4 4l10 10M14 4L4 14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
      "  </button>" +
      '  <div class="dh-xsm-media"><img alt="" data-xsm-img></div>' +
      '  <div class="dh-xsm-body">' +
      '    <div class="dh-xsm-title" data-xsm-title></div>' +
      '    <div class="dh-xsm-price" data-xsm-price></div>' +
      '    <div class="dh-xsm-options" data-xsm-options></div>' +
      '    <div class="dh-xsm-qtyrow">' +
      '      <span class="dh-xsm-qtylabel">Quantità</span>' +
      '      <div class="dh-xsm-qty">' +
      '        <button type="button" class="dh-xsm-qtybtn" data-xsm-minus aria-label="Diminuisci">−</button>' +
      '        <input class="dh-xsm-qtyinput" data-xsm-qty type="number" min="1" step="1" value="1" inputmode="numeric" aria-label="Quantità">' +
      '        <button type="button" class="dh-xsm-qtybtn" data-xsm-plus aria-label="Aumenta">+</button>' +
      "      </div>" +
      "    </div>" +
      '    <button type="button" class="dh-xsm-add" data-xsm-add>Aggiungi</button>' +
      '    <a class="dh-xsm-link" data-xsm-fulllink href="#">Vedi tutti i dettagli</a>' +
      "  </div>" +
      "</div>"
    document.body.appendChild(modal)

    modal.querySelector(".dh-xsm-close").addEventListener("click", closeModal)
    modal.addEventListener("click", function (e) {
      if (e.target === modal) closeModal()
    })
    modal.addEventListener("cancel", function () {
      document.documentElement.style.overflow = ""
    })
    return modal
  }

  function closeModal() {
    if (!modal) return
    if (modal.open) modal.close()
    document.documentElement.style.overflow = ""
  }

  function openModal(p) {
    ensureModal()

    var optionNames = (p.options || []).map(function (o) {
      return typeof o === "string" ? o : o.name
    })

    var imgEl = modal.querySelector("[data-xsm-img]")
    var titleEl = modal.querySelector("[data-xsm-title]")
    var priceEl = modal.querySelector("[data-xsm-price]")
    var optsEl = modal.querySelector("[data-xsm-options]")
    var addBtn = modal.querySelector("[data-xsm-add]")
    var linkEl = modal.querySelector("[data-xsm-fulllink]")
    var qtyInput = modal.querySelector("[data-xsm-qty]")
    var minusBtn = modal.querySelector("[data-xsm-minus]")
    var plusBtn = modal.querySelector("[data-xsm-plus]")

    qtyInput.value = 1

    var firstImg = p.featured_image || (p.images && p.images[0]) || ""
    imgEl.src = withWidth(firstImg, 240)
    imgEl.alt = escapeHtml(p.title)
    titleEl.textContent = p.title
    linkEl.href = rootUrl() + "/products/" + p.handle

    var initial = null
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].available) {
        initial = p.variants[i]
        break
      }
    }
    if (!initial) initial = p.variants[0]
    var selected = (initial.options || []).slice()

    function currentQty() {
      var n = parseInt(qtyInput.value, 10)
      if (isNaN(n) || n < 1) n = 1
      return n
    }
    function setQty(n) {
      if (n < 1) n = 1
      qtyInput.value = n
    }
    minusBtn.onclick = function () {
      setQty(currentQty() - 1)
    }
    plusBtn.onclick = function () {
      setQty(currentQty() + 1)
    }
    qtyInput.onchange = function () {
      setQty(currentQty())
    }

    function variantFor(opts) {
      return p.variants.find(function (v) {
        var vo = v.options || []
        for (var k = 0; k < opts.length; k++) {
          if (String(vo[k]) !== String(opts[k])) return false
        }
        return true
      })
    }
    function valueAvailable(optIndex, value) {
      return p.variants.some(function (v) {
        if (!v.available) return false
        var vo = v.options || []
        if (String(vo[optIndex]) !== String(value)) return false
        for (var k = 0; k < selected.length; k++) {
          if (k === optIndex) continue
          if (String(vo[k]) !== String(selected[k])) return false
        }
        return true
      })
    }

    function render() {
      optsEl.innerHTML = ""
      optionNames.forEach(function (name, idx) {
        var values = []
        p.variants.forEach(function (v) {
          var val = (v.options || [])[idx]
          if (val != null && values.indexOf(val) === -1) values.push(val)
        })
        if (values.length <= 1 && optionNames.length <= 1) return

        var group = document.createElement("div")
        group.className = "dh-xsm-optgroup"
        var lbl = document.createElement("div")
        lbl.className = "dh-xsm-optlabel"
        lbl.textContent = name
        group.appendChild(lbl)

        var row = document.createElement("div")
        row.className = "dh-xsm-optvalues"
        values.forEach(function (val) {
          var btn = document.createElement("button")
          btn.type = "button"
          btn.className = "dh-xsm-optbtn"
          btn.textContent = val
          btn.addEventListener("click", function () {
            selected[idx] = val
            update()
          })
          row.appendChild(btn)
        })
        group.appendChild(row)
        optsEl.appendChild(group)
      })
      update()
    }

    function update() {
      var groups = optsEl.querySelectorAll(".dh-xsm-optgroup")
      groups.forEach(function (group, gi) {
        group.querySelectorAll(".dh-xsm-optbtn").forEach(function (btn) {
          var val = btn.textContent
          btn.classList.toggle(
            "is-selected",
            String(selected[gi]) === String(val)
          )
          btn.classList.toggle("is-unavailable", !valueAvailable(gi, val))
        })
      })

      var v = variantFor(selected)
      if (v) {
        var img = (v.featured_image && v.featured_image.src) || firstImg
        imgEl.src = withWidth(img, 240)
        priceEl.textContent = formatEuro(v.price)
        if (v.available) {
          addBtn.disabled = false
          addBtn.textContent = "Aggiungi · " + formatEuro(v.price)
          addBtn.dataset.variantId = v.id
        } else {
          addBtn.disabled = true
          addBtn.textContent = "Esaurito"
          addBtn.removeAttribute("data-variant-id")
        }
      } else {
        addBtn.disabled = true
        addBtn.textContent = "Combinazione non disponibile"
        addBtn.removeAttribute("data-variant-id")
      }
    }

    addBtn.onclick = function () {
      var vid = addBtn.dataset.variantId
      if (!vid) return
      addToCart(vid, currentQty(), addBtn)
        .then(function () {
          closeModal()
        })
        .catch(function () {
          addBtn.textContent = "Errore, riprova"
        })
    }

    render()
    if (!modal.open) modal.showModal()
    document.documentElement.style.overflow = "hidden"
  }

  function chooseOrAdd(handle, btn) {
    if (btn) btn.setAttribute("aria-busy", "true")
    return fetch(productJsUrl(handle), {
      headers: { Accept: "application/json" },
    })
      .then(function (r) {
        return r.json()
      })
      .then(function (p) {
        if (p.variants.length === 1) {
          return addToCart(p.variants[0].id, 1, btn)
        }
        openModal(p)
      })
      .finally(function () {
        if (btn) btn.removeAttribute("aria-busy")
      })
  }

  // Frozen/pantry: apri la modale con le varianti del WRAPPER multipack
  // (stessi tagli/prezzi della PDP), mantenendo nome/immagine/link del base.
  function chooseBundle(p, wrapperHandle, btn) {
    if (btn) btn.setAttribute("aria-busy", "true")
    return fetch(productJsUrl(wrapperHandle), {
      headers: { Accept: "application/json" },
    })
      .then(function (r) {
        return r.json()
      })
      .then(function (w) {
        openModal({
          title: p.title,
          handle: p.handle,
          featured_image: p.featured_image,
          images: p.images,
          options: w.options,
          variants: w.variants,
        })
      })
      .finally(function () {
        if (btn) btn.removeAttribute("aria-busy")
      })
  }

  // ------------------------------------------------------------------- pills
  function buildPill(p) {
    var bundle = bundleFor(p.handle)
    var multi = bundle
      ? true
      : Array.isArray(p.variants)
        ? p.variants.length > 1
        : Number(p.variants_count) > 1
    var priceLabel =
      bundle && bundle.min != null
        ? "da " + formatEuro(bundle.min)
        : p.price_varies && p.price_min != null
          ? "da " + formatEuro(p.price_min)
          : formatEuro(p.price)

    var pill = document.createElement("div")
    pill.className = "cross-sell-pill"

    var img = p.featured_image ? withWidth(p.featured_image, 120) : ""
    pill.innerHTML =
      '<a class="pill-link" href="' +
      p.url +
      '">' +
      '  <span class="pill-image">' +
      (img ? '<img src="' + img + '" alt="" loading="lazy">' : "") +
      "</span>" +
      '  <span class="pill-content">' +
      '    <span class="pill-name">' +
      escapeHtml(p.title) +
      "</span>" +
      '    <span class="pill-price">' +
      priceLabel +
      "</span>" +
      "  </span>" +
      "</a>" +
      '<button type="button" class="pill-action' +
      (multi ? " is-choose" : " is-add") +
      '" aria-label="' +
      (multi ? "Scegli opzioni" : "Aggiungi al carrello") +
      '">' +
      '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M8 3v10M3 8h10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
      "<span>" +
      (multi ? "Scegli opzioni" : "Aggiungi") +
      "</span>" +
      "</button>"

    var actionBtn = pill.querySelector(".pill-action")
    actionBtn.addEventListener("click", function (e) {
      e.preventDefault()
      if (bundle) {
        chooseBundle(p, bundle.w, actionBtn).catch(function () {})
      } else if (
        !multi &&
        Array.isArray(p.variants) &&
        p.variants.length === 1
      ) {
        addToCart(p.variants[0].id, 1, actionBtn).catch(function () {})
      } else {
        chooseOrAdd(p.handle, actionBtn).catch(function () {})
      }
    })

    return pill
  }

  // ----------------------------------------------------------- custom element
  function DhCrossSell() {
    return Reflect.construct(HTMLElement, [], DhCrossSell)
  }
  DhCrossSell.prototype = Object.create(HTMLElement.prototype)
  DhCrossSell.prototype.constructor = DhCrossSell

  DhCrossSell.prototype.connectedCallback = function () {
    injectStyles()
    this.classList.add("dogheroes--cross-sell")
    if (this.dataset.context === "cart")
      this.classList.add("dogheroes--cross-sell--cart")
    // Il cart drawer di Horizon "morfa" la sezione dopo un cambio carrello e
    // puo svuotare l'innerHTML di questo elemento senza rieseguire
    // connectedCallback ne dispatchare cart:update. Un MutationObserver
    // ridipinge quando i figli spariscono e non resta ne la lista pillole ne
    // lo scheletro (le nostre mutazioni lasciano sempre uno dei due).
    if (!this._dhObserver && typeof MutationObserver !== "undefined") {
      var host = this
      this._dhObserver = new MutationObserver(function () {
        if (!host.isConnected) return
        if (
          host.querySelector(".cross-sell-pills") ||
          host.querySelector(".cross-sell-skeleton")
        )
          return
        host._dhScheduleLoad()
      })
      this._dhObserver.observe(this, { childList: true })
    }
    this.load()
  }

  DhCrossSell.prototype.disconnectedCallback = function () {
    if (this._dhObserver) {
      this._dhObserver.disconnect()
      this._dhObserver = null
    }
    if (this._dhRafPending) {
      cancelAnimationFrame(this._dhRafPending)
      this._dhRafPending = null
    }
  }

  // Ricarica al piu una volta per frame (un solo rAF pendente).
  DhCrossSell.prototype._dhScheduleLoad = function () {
    var host = this
    if (host._dhRafPending) return
    host._dhRafPending = requestAnimationFrame(function () {
      host._dhRafPending = null
      host.load()
    })
  }

  DhCrossSell.prototype.attributeChangedCallback = function (
    name,
    oldValue,
    newValue
  ) {
    if (!this.isConnected) return
    // Salta il primo upgrade (prima che load() abbia impostato _dhCacheKey):
    // il caricamento iniziale lo fa gia connectedCallback, cosi si evita un
    // secondo giro di fetch a freddo.
    if (!this._dhCacheKey) return
    if (oldValue === newValue) return
    this._dhScheduleLoad()
  }

  DhCrossSell.prototype.showSkeleton = function () {
    var heading =
      this._dhHeading ||
      this.dataset.heading ||
      "Al tuo cane potrebbe piacere anche"
    this.innerHTML =
      '<h4 class="cross-sell-heading">' +
      escapeHtml(heading) +
      "</h4>" +
      '<div class="cross-sell-pills" data-cross-sell-pills>' +
      '  <div class="cross-sell-skeleton" aria-busy="true"><span></span><span></span><span></span></div>' +
      "</div>"
  }

  DhCrossSell.prototype.paint = function (products) {
    var heading =
      this._dhHeading ||
      this.dataset.heading ||
      "Al tuo cane potrebbe piacere anche"
    this.style.display = ""
    this.innerHTML =
      '<h4 class="cross-sell-heading">' +
      escapeHtml(heading) +
      "</h4>" +
      '<div class="cross-sell-pills" data-cross-sell-pills></div>'
    var c = this.querySelector("[data-cross-sell-pills]")
    products.forEach(function (p) {
      c.appendChild(buildPill(p))
    })
  }

  DhCrossSell.prototype.load = function () {
    var host = this
    var isCart = this.dataset.context === "cart"
    var intent = this.dataset.intent || "complementary"

    // Semi per specie. PDP: singolo seme + data-species. Carrello: due liste id
    // (cane / gatto) costruite in Liquid dai tag degli item nel carrello.
    var seeds = { dog: [], cat: [] }
    if (isCart) {
      seeds.dog = splitIds(this.dataset.productIdsDog)
      seeds.cat = splitIds(this.dataset.productIdsCat)
    } else {
      var pdpSpecies = this.dataset.species === "cat" ? "cat" : "dog"
      seeds[pdpSpecies] = splitIds(this.dataset.productId)
    }

    var speciesPresent = []
    if (seeds.dog.length) speciesPresent.push("dog")
    if (seeds.cat.length) speciesPresent.push("cat")

    this._dhHeading = resolveHeading(this, speciesPresent)

    // Prodotti già nel carrello: da escludere sempre dalle raccomandazioni.
    var cartIds = isCart ? splitIds(this.dataset.productIds) : []
    // PDP: id del wrapper multipack della ricetta corrente, da non riproporre
    // fra le pillole (es. sulla PDP "Manzo e Tonno" niente pillola che porti al
    // suo stesso multipack).
    var excludeTarget = this.dataset.excludeTarget
      ? String(this.dataset.excludeTarget)
      : ""

    // Cache basata sulla firma degli attributi: il cart drawer rimpiazza questo
    // elemento in place con attributi nuovi quando cambia il carrello, quindi
    // una chiave diversa deve forzare un nuovo fetch.
    var cacheKey = [
      this.dataset.context || "",
      this.dataset.productId || "",
      this.dataset.productIdsDog || "",
      this.dataset.productIdsCat || "",
      this.dataset.species || "",
    ].join("~")
    if (host._dhProducts && host._dhCacheKey === cacheKey) {
      if (host._dhProducts.length) host.paint(host._dhProducts)
      else host.style.display = "none"
      return
    }
    host._dhCacheKey = cacheKey

    // Prodotti da NON consigliare mai:
    // - versioni "piano alimentare" dei frozen (tag frozen + subscribable):
    //   vendibili solo in abbonamento (le retail hanno tag surgelato-retail,
    //   con le sole grammature 320g/650g, e restano consigliabili)
    // - wrapper multipack (tag buy-options)
    function isPlanOnly(p) {
      var tags = (p.tags || []).map(function (t) {
        return String(t).toLowerCase()
      })
      if (tags.indexOf("buy-options") !== -1) return true
      if (tags.indexOf("subscribable") !== -1 && tags.indexOf("frozen") !== -1)
        return true
      return false
    }

    function filterOut(products) {
      return products.filter(function (p) {
        if (excludeTarget && targetIdOf(p) === excludeTarget) return false
        if (!cartIds.length) return true
        if (cartIds.indexOf(String(p.id)) !== -1) return false
        var b = bundleFor(p.handle)
        if (b && b.id != null && cartIds.indexOf(String(b.id)) !== -1)
          return false
        return true
      })
    }

    function fetchReco(which, pid) {
      return fetch(recoUrl(which, pid), {
        headers: { Accept: "application/json" },
      })
        .then(function (r) {
          return r.json()
        })
        .then(function (d) {
          return (d && d.products) || []
        })
        .then(function (list) {
          return list.filter(function (p) {
            return !isPlanOnly(p)
          })
        })
        .catch(function () {
          return []
        })
    }

    // Catena di raccomandazione per UNA specie: prova ogni seme in ordine,
    // complementary poi related, tenendo solo i prodotti della stessa specie.
    function speciesChain(seedIds, species) {
      return new Promise(function (resolve) {
        function trySeed(i) {
          if (i >= seedIds.length) {
            resolve([])
            return
          }
          fetchReco(intent, seedIds[i])
            .then(function (products) {
              if (products.length) return products
              if (intent !== "related") return fetchReco("related", seedIds[i])
              return []
            })
            .then(function (products) {
              products = bySpecies(products, species)
              if (products.length) resolve(products)
              else trySeed(i + 1)
            })
        }
        trySeed(0)
      })
    }

    // Fallback per specie: JSON già costruito in Liquid per quella specie
    // (data-fallback = cane, data-fallback-cat = gatto). Niente filtro specie:
    // sono già omogenei e non portano i tag.
    function fallbackFor(species) {
      var raw =
        species === "cat" ? host.dataset.fallbackCat : host.dataset.fallback
      if (!raw) return []
      try {
        return JSON.parse(raw) || []
      } catch (e) {
        return []
      }
    }

    // Catena reco, poi il fallback della specie se la catena è vuota.
    function recommendFor(species) {
      return speciesChain(seeds[species], species).then(function (list) {
        if (list.length) return list
        return fallbackFor(species)
      })
    }

    function done(products) {
      host._dhProducts = products
      if (products.length) host.paint(products)
      else host.style.display = "none"
    }

    if (!speciesPresent.length) {
      done([])
      return
    }

    this.showSkeleton()

    if (speciesPresent.length === 1) {
      recommendFor(speciesPresent[0]).then(function (list) {
        done(dedupByTarget(filterOut(list)).slice(0, 10))
      })
      return
    }

    // Carrello misto: raccomanda per entrambe le specie e alterna cane/gatto.
    Promise.all([recommendFor("dog"), recommendFor("cat")]).then(
      function (res) {
        var dog = filterOut(res[0])
        var cat = filterOut(res[1])
        done(dedupByTarget(interleave(dog, cat)).slice(0, 10))
      }
    )
  }

  // ------------------------------------------------------------------- styles
  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return
    var st = document.createElement("style")
    st.id = STYLE_ID
    st.textContent = CSS
    document.head.appendChild(st)
  }

  var CSS = `
  /* Allow the PDP buy column to shrink so the horizontal pill scroller
     can't blow out the two-column layout (flexbox min-width:auto fix). */
  .product-details,
  .dogheroes--buy-options { min-width: 0; max-width: 100%; }

  dh-cross-sell {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    margin-top: 16px;
  }
  /* Cart drawer: push recommendations to the bottom, right above the summary/Sconto. */
  .cart-drawer__content:has(dh-cross-sell[data-context="cart"]) .cart-drawer__summary { margin-top: 0; }
  /* Higher specificity (dh-cross-sell.<class>) to beat the base margin-top. */
  dh-cross-sell[data-context="cart"] {
    flex: 0 0 auto;
    margin-top: 0;
    padding: 10px var(--padding-xl, 20px) 8px;
    border-top: 1px solid var(--color-border, #ececec);
  }
  dh-cross-sell[data-context="cart"] .cross-sell-heading { margin-bottom: 2px; font-size: 13px; }
  dh-cross-sell[data-context="cart"] .cross-sell-pills { padding-bottom: 4px; }

  dh-cross-sell .cross-sell-heading {
    font-size: 15px; font-weight: 700; margin: 0; color: #1c2541;
    text-transform: none; letter-spacing: 0;
  }
  dh-cross-sell .cross-sell-pills {
    display: flex; min-width: 0; max-width: 100%; gap: 10px;
    overflow-x: auto; overflow-y: hidden; padding-bottom: 6px;
    scroll-snap-type: x mandatory;
    scrollbar-width: thin; scrollbar-color: #d4d4d4 transparent;
  }
  dh-cross-sell .cross-sell-pills::-webkit-scrollbar { height: 6px; }
  dh-cross-sell .cross-sell-pills::-webkit-scrollbar-thumb { background: #d4d4d4; border-radius: 3px; }
  dh-cross-sell .cross-sell-pill {
    flex: 0 0 auto; min-width: 230px; max-width: 250px;
    display: flex; align-items: center; gap: 10px;
    padding: 8px 10px 8px 8px; background: #fef5f1; border-radius: 12px;
    scroll-snap-align: start;
    transition: background-color 0.15s ease, transform 0.15s ease;
  }
  dh-cross-sell[data-context="cart"] .cross-sell-pill { min-width: 210px; max-width: 230px; }
  dh-cross-sell .cross-sell-pill:hover { background: #fde9e0; transform: translateY(-1px); }
  dh-cross-sell .pill-link {
    flex: 1; min-width: 0; display: flex; align-items: center; gap: 10px;
    text-decoration: none; color: inherit;
  }
  dh-cross-sell .pill-image {
    flex-shrink: 0; width: 48px; height: 48px; border-radius: 8px; overflow: hidden;
    background: #fff; display: flex; align-items: center; justify-content: center;
  }
  dh-cross-sell .pill-image img { width: 100%; height: 100%; object-fit: cover; display: block; }
  dh-cross-sell .pill-content { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; }
  dh-cross-sell .pill-name {
    font-size: 13.5px; font-weight: 700; color: #1c2541; line-height: 1.2;
    overflow: hidden; text-overflow: ellipsis; display: -webkit-box;
    line-clamp: 2; -webkit-line-clamp: 2; -webkit-box-orient: vertical;
  }
  dh-cross-sell .pill-price { font-size: 12.5px; font-weight: 500; color: #6b6b6b; line-height: 1.2; }
  dh-cross-sell .pill-action {
    flex-shrink: 0; display: inline-flex; align-items: center; gap: 5px;
    border: none; cursor: pointer; background: #fff; color: #e1251b;
    font-weight: 700; font-size: 12px; line-height: 1; border-radius: 999px;
    padding: 8px 10px; white-space: nowrap;
    transition: background-color 0.15s ease, color 0.15s ease;
  }
  dh-cross-sell .pill-action.is-add,
  dh-cross-sell .pill-action.is-choose { width: 34px; height: 34px; padding: 0; justify-content: center; }
  dh-cross-sell .pill-action.is-add span,
  dh-cross-sell .pill-action.is-choose span { display: none; }
  dh-cross-sell .pill-action:hover { background: #e1251b; color: #fff; }
  dh-cross-sell .pill-action[aria-busy='true'] { opacity: 0.6; pointer-events: none; }
  dh-cross-sell .cross-sell-skeleton { display: flex; gap: 10px; width: 100%; }
  dh-cross-sell .cross-sell-skeleton span {
    flex: 1; min-width: 210px; height: 64px; border-radius: 12px;
    background: linear-gradient(90deg, #f3f3f3 25%, #ececec 37%, #f3f3f3 63%);
    background-size: 400% 100%; animation: dh-cross-skel 1.4s ease infinite;
  }
  @keyframes dh-cross-skel { 0% { background-position: 100% 50%; } 100% { background-position: 0 50%; } }

  /* quick-add modal */
  .dh-xsm-dialog { border: none; background: transparent; padding: 0; max-width: 100vw; max-height: 100vh; }
  .dh-xsm-dialog::backdrop { background: rgba(28, 37, 65, 0.55); }
  .dh-xsm-dialog[open] {
    display: flex; align-items: center; justify-content: center;
    position: fixed; inset: 0; width: 100%; height: 100%;
    max-width: 100%; max-height: 100%; margin: 0; padding: 16px;
    animation: dh-xsm-fade 0.18s ease;
  }
  @keyframes dh-xsm-fade { from { opacity: 0; } to { opacity: 1; } }
  .dh-xsm-card {
    position: relative; width: 100%; max-width: 420px; background: #fff;
    border-radius: 18px; padding: 22px; display: flex; flex-direction: column; gap: 12px;
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.25); animation: dh-xsm-pop 0.2s ease;
  }
  @keyframes dh-xsm-pop { from { opacity: 0; transform: translateY(12px) scale(0.98); } to { opacity: 1; transform: translateY(0) scale(1); } }
  .dh-xsm-close {
    position: absolute; top: 12px; right: 12px; width: 32px; height: 32px; border: none;
    background: #f3f3f3; color: #1c2541; border-radius: 50%; cursor: pointer;
    display: flex; align-items: center; justify-content: center;
  }
  .dh-xsm-close:hover { background: #e6e6e6; }
  .dh-xsm-media { width: 96px; height: 96px; border-radius: 12px; overflow: hidden; background: #fef5f1; align-self: center; }
  .dh-xsm-media img { width: 100%; height: 100%; object-fit: cover; display: block; }
  .dh-xsm-title { font-size: 17px; font-weight: 700; color: #1c2541; text-align: center; line-height: 1.25; }
  .dh-xsm-price { font-size: 15px; font-weight: 600; color: #e1251b; text-align: center; }
  .dh-xsm-optgroup { display: flex; flex-direction: column; gap: 6px; }
  .dh-xsm-optlabel { font-size: 12px; font-weight: 600; color: #6b6b6b; text-transform: uppercase; letter-spacing: 0.04em; }
  .dh-xsm-optvalues { display: flex; flex-wrap: wrap; gap: 8px; }
  .dh-xsm-optbtn {
    border: 1.5px solid #e6e6e6; background: #fff; color: #1c2541; font-size: 13px; font-weight: 600;
    padding: 8px 14px; border-radius: 10px; cursor: pointer;
    transition: border-color 0.15s ease, background-color 0.15s ease;
  }
  .dh-xsm-optbtn:hover { border-color: #1c2541; }
  .dh-xsm-optbtn.is-selected { background: #1c2541; border-color: #1c2541; color: #fff; }
  .dh-xsm-optbtn.is-unavailable { opacity: 0.4; text-decoration: line-through; }
  .dh-xsm-qtyrow { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
  .dh-xsm-qtylabel { font-size: 13px; font-weight: 600; color: #1c2541; }
  .dh-xsm-qty { display: inline-flex; align-items: center; border: 1.5px solid #e6e6e6; border-radius: 10px; overflow: hidden; }
  .dh-xsm-qtybtn {
    width: 38px; height: 40px; border: none; background: #fff; color: #1c2541;
    font-size: 18px; line-height: 1; cursor: pointer;
  }
  .dh-xsm-qtybtn:hover { background: #f5f5f5; }
  .dh-xsm-qtyinput {
    width: 46px; height: 40px; border: none; text-align: center; font-size: 15px;
    font-weight: 600; color: #1c2541; -moz-appearance: textfield;
  }
  .dh-xsm-qtyinput::-webkit-outer-spin-button,
  .dh-xsm-qtyinput::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
  .dh-xsm-add {
    margin-top: 4px; border: none; background: #e1251b; color: #fff; font-size: 15px; font-weight: 700;
    padding: 13px 16px; border-radius: 14px; cursor: pointer; transition: background-color 0.15s ease;
  }
  .dh-xsm-add:hover:not(:disabled) { background: #ca2118; }
  .dh-xsm-add:disabled { background: #c9c9c9; cursor: not-allowed; }
  .dh-xsm-add[aria-busy='true'] { opacity: 0.7; pointer-events: none; }
  .dh-xsm-link { text-align: center; font-size: 12.5px; color: #6b6b6b; text-decoration: underline; }
  @media screen and (max-width: 600px) {
    .dh-xsm-dialog[open] { align-items: flex-end; padding: 0; }
    .dh-xsm-card { max-width: 100%; border-radius: 18px 18px 0 0; padding-bottom: 28px; }
  }
  `

  // Define the element only AFTER CSS is assigned, so the first
  // connectedCallback (triggered by define upgrading existing elements)
  // injects the real styles.
  injectStyles() // ensure styles exist regardless of element lifecycle timing

  DhCrossSell.observedAttributes = [
    "data-product-ids",
    "data-product-ids-dog",
    "data-product-ids-cat",
    "data-product-id",
    "data-species",
  ]

  if (!customElements.get("dh-cross-sell")) {
    customElements.define("dh-cross-sell", DhCrossSell)
  }

  // Re-paint cart drawer recommendations after a cart update (the cart section
  // is morphed on add/qty change, which can wipe the rendered pills).
  document.addEventListener("cart:update", function () {
    requestAnimationFrame(function () {
      document
        .querySelectorAll('dh-cross-sell[data-context="cart"]')
        .forEach(function (el) {
          if (typeof el.load === "function") el.load()
        })
    })
  })
})()
